var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('router-link',{staticClass:"link",attrs:{"to":"/"}},[_vm._v("Курси валют")]),_c('router-link',{staticClass:"link",attrs:{"to":"/converter"}},[_vm._v("Конвектор валют")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }